<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "AgentConfig",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'agentConfig:add',
        update: 'agentConfig:update',
        delete: 'agentConfig:delete',
        deleteBatch: 'agentConfig:deleteBatch'
      },
      url: {
        get: '/agentConfig/listByCondition',
        add: '/agentConfig/add',
        update: '/agentConfig/update',
        delete: '/agentConfig/delete/',
        delete_batch: '/agentConfig/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        width: '80',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '120',
      }, {
        field: 'qualifyThreshold',
        label: '代理门槛人数',
        show: true,
        width: '120',
      }, {
        field: 'level1RebateRate',
        label: '一级返佣比例',
        show: {
          type: 'ratio'
        },
        width: '120',
      }, {
        field: 'level2RebateRate',
        label: '二级返佣比例',
        show: {
          type: 'ratio'
        },
        width: '120',
      }, {
        field: 'ruleText',
        label: '规则说明文案',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '创建时间',
        show: {
          type: 'datetime'
        },
        width: '160',
      }],
      operate: [],
      formFields: {
        addTitle: '新增代理配置',
        updateTitle: '修改代理配置',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择代理',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'qualifyThreshold',
          label: '代理门槛人数',
          type: 'textarea',
          placeholder: '拉新几人后判定为内部代理（数字）',
          rules: [{message: '请输入代理门槛人数', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'level1RebateRate',
          label: '一级返佣比例',
          type: 'textarea',
          placeholder: '一级分润比例（如：0.2000）',
          rules: [{message: '请输入一级返佣比例', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'level2RebateRate',
          label: '二级返佣比例',
          type: 'textarea',
          placeholder: '二级分润比例（如：0.1000）',
          rules: [{message: '请输入二级返佣比例', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'ruleText',
          label: '规则文案',
          type: 'textarea',
          placeholder: '前端展示的活动/返现规则文案',
          add: true,
          update: true,
        }, {
          field: 'inviteSuccessDefinition',
          label: '成功判定规则',
          type: 'textarea',
          placeholder: '例：下级成功充值一笔算为一个成功拉新',
          add: true,
          update: true,
        }, {
          field: 'inviteLinkPrefix',
          label: '邀请链接前缀',
          type: 'textarea',
          placeholder: '例：https://xxx.com/invite?code=',
          add: true,
          update: true,
        }, {
          field: 'shareTextTemplate',
          label: '分享文本模板',
          type: 'textarea',
          placeholder: '支持占位符 {inviteCode}',
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>
